var $5693e734f8e52053$exports = {};
const $5693e734f8e52053$var$Configuration = {
    apiUrl: "https://api.staging.hint.com",
    apiVersion: "20260717161710",
    emrNotesUrl: "https://4cwadwazt5.execute-api.us-east-1.amazonaws.com/prod",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://4cwadwazt5.execute-api.us-east-1.amazonaws.com",
    emrCalendarsUrl: "https://gs0v36zjng.execute-api.us-east-1.amazonaws.com/prod",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://gs0v36zjng.execute-api.us-east-1.amazonaws.com",
    emrMessagingUrl: "https://etnba5uvjg.execute-api.us-east-1.amazonaws.com/prod",
    emrMessagingVersion: undefined,
    emrMessagingCsp: "https://etnba5uvjg.execute-api.us-east-1.amazonaws.com",
    env: "staging",
    hintEnv: "staging",
    fullStoryOrgId: undefined,
    googleMapsKey: "AIzaSyCxmha8wa6V2LP3PRgLePsIABcYxZ_-oww",
    googleRecaptchaSiteKey: "6LfHJdgZAAAAAKvTxun6iCdua-WVH0_zLqdjRh8G",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784038116",
    release: "ee0458ab2cd8ddc41ce97d7e7f29945d5a07b3a1",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "staging",
    sentryReleaseVersion: "ee0458ab2cd8ddc41ce97d7e7f29945d5a07b3a1",
    stripePublishableKey: "pk_test_Y7byiIyWmjqy4Xy7fjArJdPl",
    statuspageEmbedCode: undefined,
    emrChatAttachmentCsp: "https://*.s3.us-east-1.amazonaws.com"
};
$5693e734f8e52053$exports = $5693e734f8e52053$var$Configuration;


window.CONFIGURATION = $5693e734f8e52053$exports;


//# sourceMappingURL=member-portal-elm.dc480c7a.js.map
